<template>
  <v-dialog :value="value" max-width="620" scrollable @input="$emit('input', $event)">
    <v-card v-if="subject" class="timetable-day-dialog">
      <div class="dialog-header">
        <div class="d-flex align-center mb-3">
          <span class="dialog-code mr-3">{{ subject.subject_id }}</span>
          <v-chip v-if="levelId" small :class="Number(levelId) === 1 ? 'undergraduate' : 'graduate'">{{ $t(Number(levelId) === 1 ? 'room_timetable.undergraduate' : 'room_timetable.graduate') }}</v-chip>
          <v-spacer />
          <v-btn icon :aria-label="$t('pre_regis_add_subject.close')" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <h1 v-if="thaiName" class="dialog-title deep-orange--text">{{ thaiName }}</h1>
        <h2 v-if="englishName" class="dialog-english brown--text">{{ englishName }}</h2>
        <div class="dialog-section mt-3 d-flex align-center">
          <span class="mr-2">{{ $t('teach_table.section') }} {{ subject.section }}</span>
          <lect-or-prac-chip :item="subject" />
        </div>
      </div>
      <v-card-text class="dialog-content">
        <div v-if="teachers.length" class="dialog-info mt-4 mb-4">
          <v-icon small class="mr-2">mdi-account-outline</v-icon>
          <div><div v-for="(name, index) in teachers" :key="index">{{ name }}</div></div>
        </div>
        <div v-for="(meeting, index) in subject.teach_days || []" :key="'m' + index" class="dialog-info mt-2">
          <v-icon small class="mr-2">mdi-clock-outline</v-icon>{{ meetingText(meeting) }}
        </div>
        <template v-if="slots.length">
          <h4 class="dates-title mt-5 mb-3">{{ $t('room_timetable.actual_dates') }} <span class="dates-count">{{ slots.length }}</span></h4>
          <div class="date-list"><div v-for="(slot, index) in slots" :key="index" class="date-row">
            <span>{{ slotDate(slot.START_DATE_TIME) }}</span>
            <span>{{ slotClock(slot.START_DATE_TIME) }} – {{ slotClock(slot.END_DATE_TIME) }}</span>
          </div></div>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn text color="deep-orange" @click="$emit('details', subject)">{{ $t('room_timetable.course_details') }}<v-icon right small>mdi-arrow-top-right</v-icon></v-btn>
        <v-spacer /><v-btn text @click="$emit('input', false)">{{ $t('pre_regis_add_subject.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import LectOrPracChip from '@/views/teach_table/components/LectOrPracChip.vue';

export default {
  name: 'TimetableDayDialog',
  components: { LectOrPracChip },
  props: {
    value: Boolean,
    subject: { type: Object, default: null },
    levelId: { type: [String, Number], default: null },
    teachers: { type: Array, default: () => [] },
  },
  computed: {
    thaiName() { return this.subject.subject_tname || this.subject.subject_name_th || ''; },
    englishName() { return this.subject.subject_ename || this.subject.subject_name_en || ''; },
    slots() { return this.subject.time_slot || []; },
  },
  methods: {
    meetingText(meeting) {
      const key = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][Number(meeting.day) - 1];
      return `${this.$t('student_timetable.' + key)} ${String(meeting.time).slice(0, 5)} – ${String(meeting.time2).slice(0, 5)}`;
    },
    slotDate(value) {
      const date = dayjs(value);
      return date.locale(this.$i18n.locale).format('ddd D MMM ') + (date.year() + (this.$i18n.locale === 'th' ? 543 : 0));
    },
    slotClock(value) { return dayjs(value).format('HH:mm'); },
  },
};
</script>

<style scoped>
.timetable-day-dialog { border-radius: 14px; color: #5d4036; }
.dialog-header { padding: 20px 24px; background: #fff3ea; border-bottom: 1px solid #f1e1d6; flex-shrink: 0; }
.dialog-code { font-size: 15px; font-weight: 700; color: #866252; letter-spacing: .03em; }
.dialog-title, .dialog-english { overflow-wrap: anywhere; }
.dialog-english { margin-top: 4px; }
.dialog-section { font-size: 13px; color: #87685d; }
.dialog-content { padding: 0 24px 24px !important; font-family: "Sarabun", sans-serif; color: #6c564a !important; }
.dialog-info { display: flex; align-items: flex-start; font-size: 14px; line-height: 1.6; }
.dialog-info .v-icon { margin-top: 3px; color: #a68c7d; }
.dates-title { font-size: 14px; font-weight: 700; color: #5d4036; }
.dates-count { display: inline-block; border-radius: 12px; background: #f7e9df; padding: 1px 8px; margin-left: 6px; font-size: 12px; }
.date-list { border: 1px solid #f1e1d6; border-radius: 10px; overflow: hidden; }
.date-row { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 4px 12px; padding: 9px 12px; font-size: 13px; }
.date-row:nth-child(even) { background: #fff8f3; }
.date-row + .date-row { border-top: 1px solid #f5ebe3; }
.undergraduate { background: #e3f0df !important; color: #35553a !important; }
.graduate { background: #eae0f7 !important; color: #594273 !important; }
</style>
